import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=65531301&scoped=true"
import script from "./BigScreen.vue?vue&type=script&lang=js"
export * from "./BigScreen.vue?vue&type=script&lang=js"
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=65531301&prod&lang=scss&scoped=true"
import style1 from "../../assets/css/comon0.css?vue&type=style&index=1&id=65531301&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65531301",
  null
  
)

export default component.exports